import { ApplicationState } from '../reducers'

export const getSkusHaveFetched = (
  state: ApplicationState
): boolean | undefined => (state.skus ? state.skus.hasFetched : undefined)
